import { readStorageSafe } from './shared/readStorageSafe';
import { createStorageHooks } from './shared/storage';

const { useStorageValue: useSessionStorageValue, useStorageValueAsync: useSessionStorageValueAsync } =
	createStorageHooks(readStorageSafe((window) => window.sessionStorage));

export { useSessionStorageValue, useSessionStorageValueAsync };
